import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/product-batch-locations/`;
const pathById = `${pathBase}:locationId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const productBatchLocations = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
};
